import {
    Zap, Droplet, Wind, Wrench, Sparkles, Bug, Hammer, Paintbrush, Droplets, Flame,
    Refrigerator, WashingMachine, Microwave, Tv, CookingPot, Cctv, Blinds, Armchair,
    Sprout, LayoutGrid, Umbrella, BrickWall, SprayCan, Sofa, Utensils, Truck, Layers,
    Lamp, Wifi,
} from "lucide-react";

export const WHATSAPP_NUMBER = "918858388788";
export const whatsappLink = (msg = "Hi HOMIIE, I need help with my home.") =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const ICONS = {
    zap: Zap, droplet: Droplet, wind: Wind, wrench: Wrench, sparkles: Sparkles, bug: Bug,
    hammer: Hammer, paintbrush: Paintbrush, droplets: Droplets, flame: Flame,
    refrigerator: Refrigerator, "washing-machine": WashingMachine, microwave: Microwave,
    tv: Tv, "cooking-pot": CookingPot, cctv: Cctv, blinds: Blinds, armchair: Armchair,
    sprout: Sprout, "layout-grid": LayoutGrid, umbrella: Umbrella, "brick-wall": BrickWall,
    "spray-can": SprayCan, sofa: Sofa, utensils: Utensils, truck: Truck, layers: Layers,
    lamp: Lamp, wifi: Wifi,
};
export const serviceIcon = (key) => ICONS[key] || Wrench;

const A = (bg, fg) => ({ bg, fg });
export const SERVICE_ACCENT = {
    electrician: A("bg-amber-50", "text-amber-600"),
    plumber: A("bg-sky-50", "text-sky-600"),
    ac: A("bg-cyan-50", "text-cyan-600"),
    home_cleaning: A("bg-pink-50", "text-pink-600"),
    pest_control: A("bg-lime-50", "text-lime-600"),
    carpenter: A("bg-orange-50", "text-orange-600"),
    painting: A("bg-fuchsia-50", "text-fuchsia-600"),
    ro: A("bg-blue-50", "text-blue-600"),
    geyser: A("bg-red-50", "text-red-600"),
    refrigerator: A("bg-teal-50", "text-teal-600"),
    washing_machine: A("bg-indigo-50", "text-indigo-600"),
    microwave: A("bg-amber-50", "text-amber-700"),
    tv_repair: A("bg-slate-100", "text-slate-600"),
    chimney: A("bg-zinc-100", "text-zinc-600"),
    cctv: A("bg-sky-50", "text-sky-700"),
    curtains: A("bg-purple-50", "text-purple-600"),
    furniture_assembly: A("bg-amber-50", "text-amber-600"),
    gardening: A("bg-green-50", "text-green-600"),
    flooring: A("bg-stone-100", "text-stone-600"),
    waterproofing: A("bg-blue-50", "text-blue-700"),
    wall_repair: A("bg-orange-50", "text-orange-700"),
    deep_cleaning: A("bg-emerald-50", "text-emerald-600"),
    sofa_cleaning: A("bg-rose-50", "text-rose-600"),
    modular_kitchen: A("bg-yellow-50", "text-yellow-700"),
    moving: A("bg-indigo-50", "text-indigo-600"),
    disinfection: A("bg-cyan-50", "text-cyan-700"),
    false_ceiling: A("bg-slate-100", "text-slate-600"),
    interior_design: A("bg-violet-50", "text-violet-600"),
    home_automation: A("bg-blue-50", "text-blue-600"),
    handyman: A("bg-orange-50", "text-orange-600"),
};

// Commonly-combined services → used for smart cart recommendations
export const SERVICE_RECOMMENDATIONS = {
    electrician: ["ac", "cctv", "home_automation", "plumber"],
    plumber: ["geyser", "ro", "electrician"],
    ac: ["electrician", "deep_cleaning"],
    geyser: ["plumber", "electrician"],
    ro: ["plumber", "home_cleaning"],
    carpenter: ["painting", "furniture_assembly"],
    painting: ["carpenter", "false_ceiling", "deep_cleaning"],
    home_cleaning: ["pest_control", "sofa_cleaning", "deep_cleaning"],
    deep_cleaning: ["pest_control", "sofa_cleaning"],
    sofa_cleaning: ["deep_cleaning", "home_cleaning"],
    pest_control: ["deep_cleaning", "disinfection"],
    refrigerator: ["washing_machine", "microwave"],
    washing_machine: ["refrigerator", "microwave"],
    microwave: ["refrigerator", "chimney"],
    chimney: ["modular_kitchen", "deep_cleaning"],
    cctv: ["electrician", "home_automation"],
    home_automation: ["electrician", "cctv"],
    furniture_assembly: ["carpenter", "curtains"],
    curtains: ["furniture_assembly", "interior_design"],
    flooring: ["wall_repair", "painting"],
    waterproofing: ["wall_repair", "painting"],
    wall_repair: ["painting", "waterproofing"],
    modular_kitchen: ["chimney", "carpenter"],
    moving: ["deep_cleaning", "carpenter"],
    false_ceiling: ["painting", "electrician"],
    interior_design: ["painting", "curtains", "false_ceiling"],
    gardening: ["pest_control"],
    disinfection: ["deep_cleaning", "pest_control"],
    handyman: ["electrician", "plumber", "carpenter"],
};

export const TIME_WINDOWS = [
    "8 AM - 10 AM", "10 AM - 12 PM", "12 PM - 2 PM",
    "2 PM - 4 PM", "4 PM - 6 PM", "6 PM - 8 PM",
];

export const SOURCES = [
    "Direct", "WhatsApp", "Instagram", "Google", "Society Campaign",
    "Professional Referral", "Customer Referral", "QR Code", "Other",
];

export function nextDays(n = 7) {
    const out = [];
    const d = new Date();
    for (let i = 0; i < n; i++) {
        const dt = new Date(d);
        dt.setDate(d.getDate() + i);
        out.push({
            value: dt.toISOString().slice(0, 10),
            label: i === 0 ? "Today" : i === 1 ? "Tomorrow" : dt.toLocaleDateString("en-IN", { weekday: "short", day: "numeric", month: "short" }),
        });
    }
    return out;
}

export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;
